<template>
    <div class="review-item-like js-listPraiseBtn" @click.stop="upVote" v-bind:class="{'reviewDetail-infoTopR': isBig, active: isUpVote}">
        <div>
            <img class="review-item-praiseIcon" src="../../assets/praiseGrayBtn.png" alt="未点赞图标">
            <img class="review-item-praiseIcon" src="../../assets/review-like.png" alt="已点赞图标">
        </div>
        <span v-bind:class="{praiseNumber: isUpVote}">{{score}}</span>
    </div>
</template>

<script>
    export default {
        name: 'UpVote',
        props: {
            isUpVote: {
                type: Boolean,
                default: false
            },
            score: {
                type: Number,
                default: 0
            },
            isBig: {
                type: Boolean,
                default: false
            }
        },
        methods: {
            upVote () {
                this.$emit('on-upVote')
            }
        }
    }
</script>

<style lang="less">
    .review-item-like{
        float:right;
        &>div{
            display:inline-block;
            vertical-align:middle;
            .review-item-praiseIcon:first-child {
                display: block;
            }
            .review-item-praiseIcon:last-child {
                display: none;
            }
        }
        &.active{
            &>div{
                .review-item-praiseIcon:first-child {
                    display:none;
                }
                .review-item-praiseIcon:last-child {
                    display:block;
                }
            }
            &>span{
                color: #f6b511;
            }
        }
        img {
            width:22px;
            height:22px;
        }
        span{
            color:#777;
            font-size:12px;
            margin-left:7px;
            vertical-align:middle;
        }
        &.reviewDetail-infoTopR{
            img{
                width: 27px;
                height: 27px;
                vertical-align: middle;
            }
            span{
                margin-left: 4px;
            }
        }
    }
</style>
